import * as Shared from '@shared/lib';
import i18next from 'i18next';

interface ItemPartial {
  key?: string;
  dropRate?: number;
  type?: Shared.LootDropType;
}

const {
  RARE,
  COMMON,
  UNCOMMON,
  LEGENDARY
} = Shared.ITEM_RARITIES;

export const getItemColor = (item: ItemPartial): string => {
  if (!item.key || item.type === Shared.LootDropType.Mod) return 'text-fuchsia-300';

  if (['resonite', 'credit'].includes(item.key)) return 'text-gold';
  if (!item.dropRate) return 'text-green-400';

  if (item.dropRate >= COMMON) return 'text-gray-300';
  if (item.dropRate >= UNCOMMON) return 'text-blue-300';
  if (item.dropRate >= RARE) return 'text-purple-400';
  if (item.dropRate >= LEGENDARY) return 'text-orange-500';

  return 'text-gray-300';
};

export const getItemHex = (item: ItemPartial): string => {
  if (!item.key || item.type === Shared.LootDropType.Mod) return '#F4A8FF';

  if (['resonite', 'credit'].includes(item.key)) return '#FFD200';
  if (!item.dropRate) return '#05DF72';

  if (item.dropRate >= COMMON) return '#D4D4D4';
  if (item.dropRate >= UNCOMMON) return '#8EC5FF';
  if (item.dropRate >= RARE) return '#C27AFF';
  if (item.dropRate >= LEGENDARY) return '#FF6900';

  return '#D4D4D4';
};

export const getItemTooltip = (item: string) => {
  let base = i18next.t(`Items.${item}`);

  const data = Shared.itemData.find(i => i.key === item);
  if (item.startsWith('fish')) {
    base = `${base} - ${i18next.t('Items.foundAt', { planet: 'Avalon' })}`;
  } else if (item.startsWith('ore')) {
    base = `${base} - ${i18next.t('Items.foundAt', { planet: 'Taloris' })}`;
  } else if (data && data.planet) {
    base = `${base} - ${i18next.t(`Items.foundAt`, { planet: data.planet })}`;
  } else {
    base = `${base} - ${i18next.t('Items.foundAtAll')}`;
  }

  if (data?.faction) {
    base = `${base} ${i18next.t('Items.foundAtAgainst', { faction: data.faction })}`;
  }

  return base;
};